<template>
    <div class="form-control-root cic-textbox">
        <label v-if="label" :for="inputId" class="form-control-label">{{ label }}</label>
        <div class="form-control-input">
            <input :id="inputId" :value="value" @input="(evt) => $emit('input', evt.target.value)" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TextField',
        props: {
            value: {
                type: String,
                default: null,
            },
            inputId: {
                type: String,
                default: undefined,
            },
            label: {
                type: String,
                default: undefined,
            },
        },
        emits: ['input'],
    };
</script>
